import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import api from '../lib/api';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

const fmtDate = (d) => { if (!d) return ''; const [y,m,day]=d.split('-'); return `${day}-${m}-${y}`; };
const toNum  = (v) => { const n=parseFloat(String(v||'').replace(',','.')); return isNaN(n)?0:n; };
const dispE    = (v) => v>0 ? v.toFixed(2) : '';
const dispEuro = (v) => v>0 ? v.toFixed(2)+' €' : '';

// Payment methods a reservation/rental actually contributes to: its two-way
// split when present, otherwise its single payment_method/amount_paid pair.
const paymentContributions = (r) => {
  if (r.payment_splits?.length) {
    return r.payment_splits.map(s => ({ method: (s.method || '').toLowerCase(), amount: s.amount || 0 }));
  }
  return [{ method: (r.payment_method || 'cash').toLowerCase(), amount: r.amount_paid || r.total_amount || 0 }];
};

const CURRENT_YEAR = new Date().getFullYear();
function getDatesForYear(year) {
  const dates = [];
  const d = new Date(Date.UTC(year, 0, 1));
  while (d.getUTCFullYear() === year) {
    dates.push(d.toISOString().slice(0, 10));
    d.setUTCDate(d.getUTCDate() + 1);
  }
  return dates;
}
const ALL_DATES = getDatesForYear(CURRENT_YEAR);

// ── Observations from PDF ─────────────────────────────────────────────────────
const PDF_OBS = {
  '2026-01-12': 'Javi cobra 15€ por ir hasta San Antolín y enviar vídeo de tablas a Marcos Slash',
  '2026-01-15': 'Javi cobra 20€ por ir hasta San Antolín y estar 3h en escuela. Marcos Slash se lleva 8 tablas para reparar.',
  '2026-03-28': 'Se va a la escuela a ordenar, enviar nuevo video a Marcos con otras 4 tablas para reparar y se va a Posada a comprar la pintura. Cliente paga bono de 3 dias dos personas =190€ (95€ each)',
  '2026-03-30': 'Javi cobra 20€ de la caja por ir hasta San Antolín, recepcionar tablas reparadas por Marcos, pagarle y entregarle otras 4 tablas para reparar. 2,5h limpiando la caseta a full + 16,68€ ticket productos limpieza Alimerka',
  '2026-03-31': 'Se va a Seronda, se ponen los 4 sup en mi coche en cinchas(furgo de mingo en el taller) y se llevan a container posada. Se alquila 1 tabla a 1 despistado (mar horrible)',
  '2026-04-01': 'Se va a las 8 am a San Antolín a pagar a Marcos Slash y recepcionar las 4 tablas reparadas. 4 chavales de Seronda. Al ser 4 pax, se sube precio unitario a 20€…',
  '2026-04-02': 'Seronda, pendiente de envío de factura al acabar el grupo de Yoga',
  '2026-04-03': 'Seronda, pendiente de envío de factura al acabar el grupo de Yoga',
  '2026-04-04': 'Dieguin(35€ 3 clases) y Sobe(1 clase) quedan pagadas. Seronda pendiente de…',
  '2026-04-05': 'Javi cobra 35€ de clases pendientes de seronda + 60€ transfer + 45€ de caja = 140€ de 4 clases a seronda. Se pagan con dinero de caja 95€ a segador de almas',
  '2026-04-12': '10€ gasolina generador. 3,90€ discos. 120€ eduvillahormes. 25€ javi: bajar generador, ir a ferretería, llenar garrafa de chofa en gasolinera, ir 2 veces a naves a x cesped artificial, sacar todo el contenedor, estar con edu allí + de 3 horas',
  '2026-04-13': '1er día de Ripstar. 35 pax x 12,5 €/p. Pago pendiente (CAIXA)',
  '2026-04-14': '2o día RipStar',
  '2026-04-15': '3er día Ripstar',
  '2026-04-16': '4dia Ripstar',
  '2026-04-27': 'Primer día de Grupo DE 29 PERSONAS...',
  '2026-04-28': '3dia de Grupoc',
  '2026-04-30': '4o día RipStar SanMartín.',
  '2026-05-01': '5 día RipStar SanMartín. 1er dia Seronda...',
  '2026-05-02': '2dia Seronda San Antolin - 11 pax surf.',
  '2026-05-03': '3dia SerondaSanMartin - 14 pax surf',
  '2026-05-07': 'Se paga x Caixa 40€ de segada a Diego...',
  '2026-05-12': 'Transfer a Javi de 244€...',
  '2026-05-13': 'El dinero de Carmelitas entró día anterior en CAIXA...',
  '2026-05-14': 'Transfer a Javi DE 460€...',
};

// ── Caixa ledger seed data ────────────────────────────────────────────────────
const DIARIO_DATA = {
  '2026-01-01': { ingresos: 0,      gastos: 0,      obs: 'Herencia de año 2025 de Skulla' },
  '2026-01-13': { ingresos: 0,      gastos: 3.63,   obs: 'IONOS' },
  '2026-01-20': { ingresos: 0,      gastos: 60.14,  obs: 'IRPF MOD.111' },
  '2026-01-21': { ingresos: 2.58,   gastos: 0,      obs: 'Transfer en Div.' },
  '2026-01-27': { ingresos: 0,      gastos: 4.24,   obs: 'IONOS' },
  '2026-01-28': { ingresos: 240,    gastos: 0,      obs: 'Dev Préstamo J' },
  '2026-02-02': { ingresos: 0,      gastos: 13,     obs: 'Spotify+Whatsapp' },
  '2026-02-13': { ingresos: 0,      gastos: 3.63,   obs: 'IONOS' },
  '2026-02-20': { ingresos: 0,      gastos: 60.14,  obs: 'IRPF MOD.111' },
  '2026-02-27': { ingresos: 0,      gastos: 4.24,   obs: 'IONOS' },
  '2026-03-02': { ingresos: 0,      gastos: 13,     obs: 'Spotify+Whatsapp' },
  '2026-03-13': { ingresos: 0,      gastos: 3.63,   obs: 'IONOS' },
  '2026-03-20': { ingresos: 0,      gastos: 60.14,  obs: 'IRPF MOD.111' },
  '2026-03-27': { ingresos: 0,      gastos: 4.24,   obs: 'IONOS' },
  '2026-03-28': { ingresos: 190,    gastos: 0,      obs: 'Bono 3 días 2pax' },
  '2026-03-30': { ingresos: 0,      gastos: 36.68,  obs: 'Javi+Alimerka' },
  '2026-04-02': { ingresos: 0,      gastos: 13,     obs: 'Spotify+Whatsapp' },
  '2026-04-05': { ingresos: 0,      gastos: 95,     obs: 'Segador de Almas' },
  '2026-04-12': { ingresos: 0,      gastos: 158.90, obs: 'Gasolina+discos+Edu+Javi' },
  '2026-04-13': { ingresos: 437.50, gastos: 0,      obs: 'RipStar día 1 (CAIXA)' },
  '2026-04-14': { ingresos: 437.50, gastos: 0,      obs: 'RipStar día 2' },
  '2026-04-15': { ingresos: 437.50, gastos: 0,      obs: 'RipStar día 3' },
  '2026-04-16': { ingresos: 437.50, gastos: 0,      obs: 'RipStar día 4' },
  '2026-04-27': { ingresos: 0,      gastos: 0,      obs: 'Grupo 29 pax' },
  '2026-05-02': { ingresos: 0,      gastos: 13,     obs: 'Spotify+Whatsapp' },
  '2026-05-07': { ingresos: 0,      gastos: 40,     obs: 'Segada Diego (Caixa)' },
  '2026-05-12': { ingresos: 0,      gastos: 244,    obs: 'Transfer a Javi' },
  '2026-05-13': { ingresos: 3.63,   gastos: 3.63,   obs: 'IONOS + Carmelitas CAIXA' },
  '2026-05-14': { ingresos: 0,      gastos: 460,    obs: 'Transfer a Javi' },
  '2026-05-20': { ingresos: 0,      gastos: 60.14,  obs: 'IRPF MOD.111' },
  '2026-05-27': { ingresos: 0,      gastos: 4.24,   obs: 'IONOS' },
};

// ── Editable cell ─────────────────────────────────────────────────────────────
function EC({ val, onChange, color, edited, align = 'right', style = {}, suffix = '', forceColor = null }) {
  const [editing, setEditing] = useState(false);
  const [draft,   setDraft]   = useState('');

  const startEdit = () => { setDraft(val != null ? String(val) : ''); setEditing(true); };
  const commit = () => { setEditing(false); onChange(draft); };

  const displayColor = forceColor || (edited ? (color || '#1A2B3C') : '#1A2B3C');

  if (editing) {
    return (
      <input
        autoFocus value={draft}
        onChange={e => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={e => { if (e.key==='Enter') commit(); if (e.key==='Escape') setEditing(false); }}
        style={{ width:'100%', background:'transparent', border:'none',
          borderBottom:'1px solid #4A6D7C', outline:'none',
          color: displayColor, fontSize:11, padding:'1px 2px',
          textAlign: align, ...style }}
      />
    );
  }
  return (
    <span onClick={startEdit} style={{
      cursor:'pointer', color: displayColor,
      fontWeight: edited ? 700 : 400, fontSize:11,
      display:'block', width:'100%', minHeight:17,
      textAlign: align, verticalAlign:'bottom', ...style,
    }}>{val}{suffix && val !== '' && val != null ? suffix : ''}</span>
  );
}

// ── Read-only cell with optional breakdown popover ────────────────────────────
function RC({ val, suffix = '', color = '#1A2B3C', breakdown = null, align = 'right', style = {} }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const hasBreak = breakdown && breakdown.length > 0;
  useEffect(() => {
    if (!open) return;
    const fn = e => { if (!ref.current?.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', fn);
    return () => document.removeEventListener('mousedown', fn);
  }, [open]);
  return (
    <div ref={ref} style={{ position:'relative', textAlign:align, ...style }}>
      <span
        onClick={() => hasBreak && setOpen(o => !o)}
        style={{ cursor:hasBreak?'pointer':'default', color, fontSize:11,
          display:'block', width:'100%', minHeight:17,
          userSelect:'none',
          whiteSpace: align==='left'?'normal':'nowrap',
          wordBreak: align==='left'?'break-word':'normal',
          lineHeight: align==='left'?'1.4':'1',
        }}
      >
        {val}{suffix && val !== '' && val != null ? suffix : ''}
        {hasBreak && <span style={{ fontSize:8, color:'#8A9BA8', marginLeft:2 }}>▾</span>}
      </span>
      {open && hasBreak && (
        <div style={{ position:'absolute', zIndex:200, top:'100%', left:0, right:'auto',
          background:'#fff', border:'1px solid #E0E7EF', borderRadius:8, padding:'6px 10px',
          minWidth:160, maxWidth:280, boxShadow:'0 4px 16px rgba(0,0,0,0.12)', whiteSpace:'nowrap',
        }}>
          {breakdown.map((item, i) => (
            <div key={i} style={{ display:'flex', justifyContent:'space-between', gap:12, padding:'2px 0', fontSize:11 }}>
              <span style={{ color:'#5C6E7A' }}>{item.label}</span>
              <span style={{ fontWeight:600, color:item.color||'#1A2B3C' }}>{item.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── Main component ────────────────────────────────────────────────────────────
export default function ExcelSkullPage() {
  const { bizumRecipients } = useAuth();
  const [tab,      setTab]      = useState('anual');
  const [rows,     setRows]     = useState({});
  const [saving,   setSaving]   = useState(false);
  const [search,   setSearch]   = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo,   setDateTo]   = useState('');
  const [loading,  setLoading]  = useState(false);

  const [coursesData, setCoursesData] = useState([]);
  const [transData,   setTransData]   = useState([]);
  const [rentalsData, setRentalsData] = useState([]);

  const diarioRef = useRef(null);
  const bizumRef  = useRef(null);
  const anualRef  = useRef(null);
  const TODAY = new Date().toISOString().slice(0, 10);

  // ── Fetch manual cell overrides ───────────────────────────────────────────
  const fetchManual = useCallback(async () => {
    try {
      const res = await api.get('/excel-skull/cells');
      const cells = res.data || [];
      const map = {};
      cells.forEach(r => {
        map[r.date] = map[r.date] || {};
        map[r.date][r.col] = r.val;
      });
      setRows(map);
    } catch (e) { toast.error('Error cargando datos guardados'); }
  }, []);

  // ── Fetch live API data ───────────────────────────────────────────────────
  const fetchApiData = useCallback(async () => {
    setLoading(true);
    try {
      const [cRes, tRes, rRes] = await Promise.all([
        api.get('/courses?limit=2000'),
        api.get('/transactions?limit=5000'),
        api.get('/rentals?limit=2000'),
      ]);
      const courses = cRes.data?.courses  || (Array.isArray(cRes.data)  ? cRes.data  : []);
      const trans   = tRes.data?.transactions || (Array.isArray(tRes.data) ? tRes.data : []);
      const rentals = rRes.data?.rentals  || (Array.isArray(rRes.data)  ? rRes.data  : []);
      setCoursesData(courses);
      setTransData(trans);
      setRentalsData(rentals);
    } catch (e) { toast.error('Error cargando datos de la app'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchManual(); fetchApiData(); }, [fetchManual, fetchApiData]);
  useEffect(() => {
    const onFocus = () => fetchApiData();
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, [fetchApiData]);

  // ── Scroll to today when tab changes ─────────────────────────────────────
  useEffect(() => {
    const today = TODAY;
    const refMap = { diario: diarioRef, bizum: bizumRef, anual: anualRef };
    const container = refMap[tab]?.current;
    if (!container) return;
    const scrollToToday = () => {
      const row = container.querySelector(`tr[data-date="${today}"]`);
      if (!row) return;
      const containerH = container.clientHeight;
      const rowTop = row.offsetTop;
      const rowH = row.offsetHeight;
      container.scrollTop = rowTop - containerH / 2 + rowH / 2;
    };
    // Small delay to let the DOM render before scrolling
    const t = setTimeout(scrollToToday, 50);
    return () => clearTimeout(t);
  }, [tab]);

  // ── Cell setter ───────────────────────────────────────────────────────────
  const setV = useCallback((date, col, raw) => {
    setRows(prev => ({ ...prev, [date]: { ...(prev[date]||{}), [col]: raw } }));
  }, []);

  // ── Save ──────────────────────────────────────────────────────────────────
  const saveAll = useCallback(async () => {
    setSaving(true);
    try {
      const entries = [];
      Object.entries(rows).forEach(([date, cols]) => {
        Object.entries(cols).forEach(([col, val]) => {
          if (val !== undefined) entries.push({ date, col, val });
        });
      });
      await api.post('/excel-skull/cells/bulk', { entries });
      toast.success('Guardado');
    } catch (e) { toast.error('Error guardando'); }
    finally { setSaving(false); }
  }, [rows]);

  // ── Index API data by date ────────────────────────────────────────────────
  const coursesByDate = useMemo(() => {
    const map = {};
    for (const c of coursesData) {
      if (!map[c.date]) map[c.date] = [];
      map[c.date].push(c);
    }
    return map;
  }, [coursesData]);

  const transByDate = useMemo(() => {
    const map = {};
    for (const t of transData) {
      const d = t.date;
      if (!map[d]) map[d] = [];
      map[d].push(t);
    }
    return map;
  }, [transData]);

  const rentalsByDate = useMemo(() => {
    const map = {};
    for (const r of rentalsData) {
      const d = r.date || r.start_date;
      if (!d) continue;
      if (!map[d]) map[d] = [];
      map[d].push(r);
    }
    return map;
  }, [rentalsData]);

  // ── Anual rows ────────────────────────────────────────────────────────────
  const allRows = useMemo(() => ALL_DATES.map(date => {
    const manualR = rows[date] || {};
    const getM = (col) => manualR[col] !== undefined ? manualR[col] : null;

    const cs = coursesByDate[date] || [];
    const ts = transByDate[date]   || [];
    const rs = rentalsByDate[date] || [];

    // Breakdown arrays
    const nAlBreakdown = [];
    const ePersBreakdown_map = {};
    const nMonBreakdown = [];
    const eMonBreakdown = [];
    const alqBreakdown = [];
    const gCajaBreakdown = [];
    const gCaixaBreakdown = [];
    const bizumBreakdown = [];
    const caixaIncBreakdown = [];
    const cashBreakdown = [];

    // Helper to format payment method labels
    const fmtPm = pm => pm === 'cash' ? 'Efectivo' : pm === 'caixa' ? 'Caixa' : pm.startsWith('bizum_') ? `Bizum ${pm.slice(6,7).toUpperCase()}${pm.slice(7)}` : pm;

    let autoNAl=0, autoEPers=0, autoNMon=0, autoEMon=0, autoEPersBizum=0, autoEPersCaixa=0;
    for (const c of cs) {
      let courseStudents = 0;
      for (const r of (c.reservations||[])) {
        const rStudents = r.num_students||0;
        autoNAl += rStudents;
        courseStudents += rStudents;
        for (const { method: rPm, amount: rAmt } of paymentContributions(r)) {
          if (rPm.startsWith('bizum'))  autoEPersBizum += rAmt;
          else if (rPm === 'caixa')     autoEPersCaixa += rAmt;
          else                          autoEPers       += rAmt;
          if (rAmt > 0) {
            ePersBreakdown_map[rPm] = (ePersBreakdown_map[rPm]||0) + rAmt;
            if (rPm.startsWith('bizum')) bizumBreakdown.push({ label: r.reservation_name||r.client_name||'Reserva', value: rAmt.toFixed(2)+'€' });
            else if (rPm === 'caixa') caixaIncBreakdown.push({ label: r.reservation_name||r.client_name||'Reserva', value: rAmt.toFixed(2)+'€' });
          }
        }
      }
      if (courseStudents > 0) {
        const loc = c.location || c.spot || c.name || 'Clase';
        nAlBreakdown.push({ label: loc, value: String(courseStudents) });
      }
      const courseMonitors = c.monitors?.filter(m=>m.name?.trim()) || [];
      autoNMon += courseMonitors.length;
      for (const m of courseMonitors) {
        autoEMon += m.cost||0;
        if (m.name?.trim()) nMonBreakdown.push({ label: m.name.trim(), value: String(m.cost||0)+'€' });
        if ((m.cost||0) > 0) eMonBreakdown.push({ label: m.name?.trim()||'Monitor', value: (m.cost||0).toFixed(2)+'€', color:'#E07070' });
      }
    }

    // Convert ePersBreakdown_map to array
    const ePersBreakdown = Object.entries(ePersBreakdown_map).filter(([,v])=>v>0).map(([pm,amt])=>({ label:fmtPm(pm), value:amt.toFixed(2)+'€' }));

    let autoAlq=0, caixaRentals=0, bizumRentals=0, cashRentals=0;
    // Pools of individual rental contribution amounts, consumed one at a time by a matching
    // manual transaction below — a manual entry can only be treated as a duplicate re-entry
    // of a rental's own payment if its amount (near-)exactly matches one still-unclaimed
    // amount in the corresponding pool. This avoids the old bug where a large, unrelated
    // manual entry got partially discarded just because a small same-day rental existed in
    // the same category (e.g. a 7.308€ manual "caixa" income losing 120€ to an unrelated
    // 120€ material rental also paid in caixa that same day).
    const rentalPoolCaixa = [], rentalPoolBizum = [], rentalPoolCash = [];
    for (const r of rs) {
      const amt = r.amount_paid||r.total_amount||0;
      autoAlq += amt;
      for (const { method: rPm, amount: partAmt } of paymentContributions(r)) {
        if (rPm === 'caixa')          caixaRentals += partAmt;
        if (rPm.startsWith('bizum'))  bizumRentals  += partAmt;
        if (rPm === 'cash')           cashRentals   += partAmt;
        if (partAmt > 0) {
          if (rPm === 'caixa') rentalPoolCaixa.push(partAmt);
          if (rPm.startsWith('bizum')) rentalPoolBizum.push(partAmt);
          if (rPm === 'cash') rentalPoolCash.push(partAmt);
          const label = `${r.equipment_type||r.client_name||'Alquiler'}${r.num_items>1?` ×${r.num_items}`:''} (${fmtPm(rPm)})`;
          alqBreakdown.push({ label, value: partAmt.toFixed(2)+'€' });
          if (rPm.startsWith('bizum')) bizumBreakdown.push({ label, value: partAmt.toFixed(2)+'€' });
          else if (rPm === 'caixa') caixaIncBreakdown.push({ label, value: partAmt.toFixed(2)+'€' });
        }
      }
    }

    const claimRental = (pool, amount, tol = 0.02) => {
      const idx = pool.findIndex(a => Math.abs(a - amount) <= tol);
      if (idx === -1) return false;
      pool.splice(idx, 1);
      return true;
    };

    let autoBizum=autoEPersBizum, autoCaixaInc=autoEPersCaixa, autoCash=0, autoCamisetas=0;
    let autoGCaja=0, autoGCaixa=0;
    for (const t of ts) {
      const amt = t.amount||0;
      const pm  = (t.payment_method||'').toLowerCase();
      const cat = (t.category||'').toLowerCase();
      const isAuto = t.type==='income' && (t.auto_key||t.auto_generated);
      if (t.type==='income' && !isAuto) {
        // Exclude auto-generated income (already counted via ePersonas + alquileres)
        if (pm.startsWith('bizum')||cat.startsWith('bizum')) {
          if (!claimRental(rentalPoolBizum, amt)) {
            autoBizum += amt;
            if (amt > 0) bizumBreakdown.push({ label: t.description||t.observations||fmtPm(pm)||'Bizum', value: amt.toFixed(2)+'€' });
          }
        }
        else if (pm==='cash'||cat==='cash') {
          if (!claimRental(rentalPoolCash, amt)) {
            autoCash += amt;
            if (amt > 0) cashBreakdown.push({ label: t.description||t.observations||'Cash', value: amt.toFixed(2)+'€' });
          }
        }
        else if (pm==='caixa'||cat==='caixa'||
                 cat==='carlos'||cat==='javier'||
                 cat==='alfredo') {
          if ((pm==='caixa'||cat==='caixa') && claimRental(rentalPoolCaixa, amt)) {
            // duplicate re-entry of a rental already counted via alquileres — skip
          } else {
            autoCaixaInc += amt;
            if (amt > 0) caixaIncBreakdown.push({ label: t.description||t.observations||fmtPm(pm)||'Caixa', value: amt.toFixed(2)+'€' });
          }
        }
        else if (cat==='camiseta'||pm==='camiseta')    autoCamisetas += amt;
      } else if (t.type==='expense') {
        // camiseta/personas (alfredo,javier,carlos) y caixa siempre van a Gastos Caixa
        const isCaixa = pm==='caixa'||cat==='caixa'||
                        pm==='carlos'||cat==='carlos'||
                        pm==='javier'||cat==='javier'||
                        pm==='alfredo'||cat==='alfredo'||
                        pm==='camiseta'||cat==='camiseta';
        if (isCaixa) {
          autoGCaixa += amt;
          gCaixaBreakdown.push({ label: t.description||t.observations||cat||'Gasto', value: amt.toFixed(2)+'€', color:'#E07070' });
        } else {
          autoGCaja += amt;
          gCajaBreakdown.push({ label: t.description||t.observations||cat||'Gasto', value: amt.toFixed(2)+'€', color:'#E07070' });
        }
      }
    }

    const resolve = (col, autoVal) => {
      const m = getM(col);
      if (m !== null && m !== '') return m;
      return autoVal > 0 ? String(Number.isInteger(autoVal) ? autoVal : autoVal.toFixed(2)) : '';
    };

    const nAlumnos   = resolve('nAlumnos',   autoNAl);
    const ePersonas  = resolve('ePersonas',  autoEPers);
    const nMonitores = resolve('nMonitores', autoNMon);
    const eMonitores = resolve('eMonitores', autoEMon);
    const camisetas  = resolve('camisetas',  autoCamisetas);
    const alquileres = resolve('alquileres', autoAlq);
    const gastosCaja = resolve('gastosCaja', autoGCaja);
    const gastosCaixa= resolve('gastosCaixa',autoGCaixa);
    const bizum      = resolve('bizum',      autoBizum);
    const caixaInc   = resolve('caixaInc',   autoCaixaInc);
    const cash       = resolve('cash',       autoCash);
    const cajaFuerte = getM('cajaFuerte')??'';
    const obs        = getM('obs')??PDF_OBS[date]??'';

    const ePersonasN  = toNum(ePersonas);
    const eMonitoresN = toNum(eMonitores);
    const camisetasN  = toNum(camisetas);
    const alquileresN = toNum(alquileres);
    const gastosCajaN = toNum(gastosCaja);
    const gastosCaixaN= toNum(gastosCaixa);
    const bizumN      = toNum(bizum);
    const caixaIncN   = toNum(caixaInc);
    const cashN       = toNum(cash);

    // BRUTO = all income transactions (bizum+caixa+cash+camisetas) matches Dashboard gross_income
    const bruto = ePersonasN + camisetasN + alquileresN + bizumN + caixaIncN + cashN;
    const neto  = bruto - gastosCajaN - gastosCaixaN - eMonitoresN;

    const hasData = !!(nAlumnos||ePersonas||nMonitores||eMonitores||
      camisetas||alquileres||gastosCaja||gastosCaixa||
      bizum||caixaInc||cash||cajaFuerte||obs);

    return {
      date, nAlumnos, ePersonas, nMonitores, eMonitores, camisetas, alquileres,
      gastosCaja, gastosCaixa, bizum, caixaInc, cash, cajaFuerte, obs,
      bruto, neto, hasData, hasBizumRentals: bizumRentals > 0, hasCaixaRentals: caixaRentals > 0,
      ePersonasN, eMonitoresN, camisetasN, alquileresN, gastosCajaN,
      gastosCaixaN, bizumN, caixaIncN, cashN,
      editedCols: manualR,
      nAlBreakdown, ePersBreakdown, nMonBreakdown, eMonBreakdown,
      alqBreakdown, gCajaBreakdown, gCaixaBreakdown,
      bizumBreakdown, caixaIncBreakdown, cashBreakdown,
    };
  }), [rows, coursesByDate, transByDate, rentalsByDate]);

  // ── Totals ────────────────────────────────────────────────────────────────
  const totals = useMemo(() => allRows.reduce((acc, r) => ({
    nAlumnos:    acc.nAlumnos   + toNum(r.nAlumnos),
    nMonitores:  acc.nMonitores + toNum(r.nMonitores),
    ePersonas:   acc.ePersonas  + r.ePersonasN,
    eMonitores:  acc.eMonitores + r.eMonitoresN,
    camisetas:   acc.camisetas  + r.camisetasN,
    alquileres:  acc.alquileres + r.alquileresN,
    gastosCaja:  acc.gastosCaja + r.gastosCajaN,
    gastosCaixa: acc.gastosCaixa+ r.gastosCaixaN,
    bizum:       acc.bizum      + r.bizumN,
    caixaInc:    acc.caixaInc   + r.caixaIncN,
    cash:        acc.cash       + r.cashN,
    bruto:       acc.bruto      + r.bruto,
    neto:        acc.neto       + r.neto,
  }), { nAlumnos:0,nMonitores:0,ePersonas:0,eMonitores:0,camisetas:0,alquileres:0,gastosCaja:0,gastosCaixa:0,bizum:0,caixaInc:0,cash:0,bruto:0,neto:0 }),
  [allRows]);

  // ── Filtered rows ─────────────────────────────────────────────────────────
  const filteredRows = useMemo(() => {
    let base = allRows;
    if (dateFrom) base = base.filter(r => r.date >= dateFrom);
    if (dateTo)   base = base.filter(r => r.date <= dateTo);
    if (!search.trim()) return base;
    const q = search.toLowerCase();
    return base.filter(r =>
      fmtDate(r.date).includes(q) ||
      String(r.obs||'').toLowerCase().includes(q) ||
      String(r.ePersonas||'').includes(q)
    );
  }, [allRows, dateFrom, dateTo, search]);

  // ── Caixa (diario) rows ───────────────────────────────────────────────────
  const diarioRows = useMemo(() => {
    let running = 0;
    return ALL_DATES.map(date => {
      const r   = rows[date] || {};
      const ts  = transByDate[date] || [];
      const cs  = coursesByDate[date] || [];
      const rs  = rentalsByDate[date] || [];

      let autoIngresos = 0;
      let autoGastos   = 0;
      const autoObsParts = [];

      // Course reservations paid via caixa — read directly from reservation data
      // (auto_key transactions are skipped below; this ensures May 23-24 style courses appear)
      // caixaPool: individual amounts, consumed one at a time by an exactly-matching manual
      // transaction below — see claimRental comment in the combined tab for why this must be
      // an exact-match claim rather than a blind day-total cap.
      const caixaPool = [];
      let recordsCaixaTotal = 0;
      for (const c of cs) {
        for (const res of (c.reservations||[])) {
          for (const { method, amount } of paymentContributions(res)) {
            if (method === 'caixa' && amount > 0) { autoIngresos += amount; recordsCaixaTotal += amount; caixaPool.push(amount); }
          }
        }
      }

      // Rentals paid via caixa
      for (const rental of rs) {
        for (const { method, amount } of paymentContributions(rental)) {
          if (method === 'caixa' && amount > 0) { autoIngresos += amount; recordsCaixaTotal += amount; caixaPool.push(amount); }
        }
      }

      for (const t of ts) {
        if (t.auto_key || t.auto_generated) continue;
        const pm  = (t.payment_method||'').toLowerCase();
        const cat = (t.category||'').toLowerCase();
        const isCaixaGroup = pm==='caixa'||cat==='caixa'||cat==='javier'||cat==='carlos'||cat==='alfredo';
        if (!isCaixaGroup) continue;
        const obs = t.observations || t.description || '';
        const amt = t.amount||0;
        if (t.type === 'income') {
          // Dedup: skip manual caixa/pm='caixa' transactions that exactly re-enter a rental
          // or course record already counted above
          let isDupe = false;
          if (pm==='caixa'||cat==='caixa') {
            const idx = caixaPool.findIndex(a => Math.abs(a - amt) <= 0.02);
            if (idx !== -1) { caixaPool.splice(idx, 1); isDupe = true; }
          }
          if (!isDupe) {
            autoIngresos += amt;
            if (obs) autoObsParts.push(obs);
          }
        } else if (t.type === 'expense') {
          autoGastos += amt;
          if (obs) autoObsParts.push(obs);
        }
      }

      const gastosRaw   = r['dc_gastos'];
      const gastosVal   = (gastosRaw!==undefined && gastosRaw!=='') ? toNum(gastosRaw) : autoGastos;
      const ingresosRaw = r['dc_ingresos'];
      const ingresosVal = (ingresosRaw!==undefined && ingresosRaw!=='') ? toNum(ingresosRaw) : autoIngresos;
      const obsRaw      = r['dc_obs'];
      const autoObs     = autoObsParts.join(' // ') || PDF_OBS[date] || '';
      const obsVal      = (obsRaw!==undefined && obsRaw!=='') ? obsRaw : autoObs;
      const saldoRaw    = r['dc_saldo'];
      let saldoVal;
      if (saldoRaw!==undefined && saldoRaw!=='') {
        saldoVal = toNum(saldoRaw);
        running  = saldoVal;
      } else {
        running  = running + ingresosVal - gastosVal;
        saldoVal = running;
      }
      const hasData = gastosVal>0||ingresosVal>0||obsVal!=='';
      return { date, gastosVal, ingresosVal, saldoVal, obsVal, hasData };
    });
  }, [rows, transByDate, coursesByDate, rentalsByDate]);

  const filteredDiarioRows = useMemo(() => {
    const q = search.trim().toLowerCase();
    return diarioRows.filter(r => {
      if (dateFrom && r.date < dateFrom) return false;
      if (dateTo   && r.date > dateTo)   return false;
      if (q && !String(r.obsVal||'').toLowerCase().includes(q) &&
               !fmtDate(r.date).toLowerCase().includes(q)) return false;
      return true;
    });
  }, [diarioRows, dateFrom, dateTo, search]);

  const diarioTotals = useMemo(() => {
    const acc = filteredDiarioRows.reduce(
      (a,r) => ({ gastos: a.gastos+r.gastosVal, ingresos: a.ingresos+r.ingresosVal }),
      { gastos:0, ingresos:0 }
    );
    const lastRow = filteredDiarioRows[filteredDiarioRows.length - 1];
    return { ...acc, saldo: lastRow?.saldoVal ?? 0 };
  }, [filteredDiarioRows]);

  // ── Bizum tab rows ────────────────────────────────────────────────────────
  const bizumRows = useMemo(() => {
    const recipients = bizumRecipients || [];
    return ALL_DATES.map(date => {
      const cs = coursesByDate[date] || [];
      const ts = transByDate[date]   || [];
      const rs = rentalsByDate[date] || [];
      const manualR = rows[date] || {};
      const getM = (col) => manualR[col] !== undefined ? manualR[col] : null;

      const autoAmounts = {};
      recipients.forEach(r => { autoAmounts[r.id] = 0; });
      let hasAlquiler = false;

      // Reservas de cursos
      for (const c of cs) {
        for (const res of (c.reservations||[])) {
          for (const { method: pm, amount } of paymentContributions(res)) {
            for (const rec of recipients) {
              if (pm === `bizum_${rec.id}`) autoAmounts[rec.id] += amount;
            }
          }
        }
      }

      // Alquileres con bizum_* — pool de importes individuales por destinatario, consumido por
      // coincidencia exacta desde los ingresos manuales de abajo (ver claimRental en la
      // pestaña combinada: evita descontar un ingreso manual grande no relacionado solo
      // porque coincide la categoría bizum_<destinatario> ese mismo día).
      const bizumRentalPool = {};
      for (const res of rs) {
        for (const { method: pm, amount: amt } of paymentContributions(res)) {
          for (const rec of recipients) {
            if (pm === `bizum_${rec.id}`) {
              autoAmounts[rec.id] += amt;
              if (amt > 0) {
                (bizumRentalPool[rec.id] = bizumRentalPool[rec.id] || []).push(amt);
                hasAlquiler = true;
              }
            }
          }
        }
      }

      // Ingresos manuales (no auto-generados) — dedup: solo si coinciden (casi) exactamente
      // con un alquiler concreto aún no reclamado de ese destinatario
      for (const t of ts) {
        if (t.type!=='income') continue;
        if (t.auto_key||t.auto_generated) continue;
        const cat = (t.category||'').toLowerCase();
        const pm  = (t.payment_method||'').toLowerCase();
        const amt = t.amount||0;
        for (const rec of recipients) {
          if (cat===`bizum_${rec.id}`||pm===`bizum_${rec.id}`) {
            const pool = bizumRentalPool[rec.id] || [];
            const idx = pool.findIndex(a => Math.abs(a - amt) <= 0.02);
            if (idx !== -1) pool.splice(idx, 1);
            else autoAmounts[rec.id] += amt;
          }
        }
      }

      const vals = {};
      const nums = {};
      recipients.forEach(rec => {
        const col = `bz_${rec.id}`;
        const auto = autoAmounts[rec.id];
        vals[rec.id] = getM(col)!==null ? getM(col) : (auto>0 ? auto.toFixed(2) : '');
        nums[rec.id] = toNum(vals[rec.id]);
      });

      const autoObs = hasAlquiler ? 'Alquileres' : '';
      const obsVal  = getM('bz_obs')!==null ? getM('bz_obs') : autoObs;
      const hasData = recipients.some(rec => nums[rec.id]>0) || obsVal!=='';
      return { date, vals, nums, obsVal, hasData };
    });
  }, [coursesByDate, transByDate, rentalsByDate, rows, bizumRecipients]);

  const filteredBizumRows = useMemo(() => {
    const q = search.trim().toLowerCase();
    return bizumRows.filter(r => {
      if (dateFrom && r.date < dateFrom) return false;
      if (dateTo   && r.date > dateTo)   return false;
      if (q && !String(r.obsVal||'').toLowerCase().includes(q) &&
               !fmtDate(r.date).toLowerCase().includes(q)) return false;
      return true;
    });
  }, [bizumRows, dateFrom, dateTo, search]);

  const bizumTotals = useMemo(() => {
    const acc = {};
    (bizumRecipients||[]).forEach(r => { acc[r.id] = 0; });
    filteredBizumRows.forEach(row => {
      (bizumRecipients||[]).forEach(r => { acc[r.id] += row.nums[r.id] || 0; });
    });
    return acc;
  }, [filteredBizumRows, bizumRecipients]);

  // ── Exports ───────────────────────────────────────────────────────────────
  const exportAnualCSV = useCallback(() => {
    const header = ['Fecha','nAlumnos','€/Persona','nMonitores','€Monitores','Camisetas','Alquileres','GastosCaja','GastosCaixa','Bizum','CaixaInc','Cash','CajaFuerte','Neto','Bruto','Obs'];
    const csvRows = [header.join(',')];
    allRows.filter(r=>r.hasData).forEach(r => {
      csvRows.push([
        fmtDate(r.date), r.nAlumnos, r.ePersonas, r.nMonitores, r.eMonitores,
        r.camisetas, r.alquileres, r.gastosCaja, r.gastosCaixa, r.bizum,
        r.caixaInc, r.cash, r.cajaFuerte, r.neto.toFixed(2), r.bruto.toFixed(2),
        `"${String(r.obs||'').replace(/"/g,'""')}"`,
      ].join(','));
    });
    const blob = new Blob([csvRows.join('\n')], { type:'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href=url; a.download='excel_skull_anual.csv'; a.click();
    URL.revokeObjectURL(url);
  }, [allRows]);

  const exportAnualPDF = useCallback(() => {
    const doc = new jsPDF({ orientation:'landscape', unit:'pt', format:'a3' });
    doc.setFontSize(14);
    doc.text(`Diario Caja — Excel Skull ${CURRENT_YEAR}`, 40, 40);
    autoTable(doc, {
      startY: 60,
      head: [['Fecha','nAl','€/P','nMon','€Mon','Cam','Alq','GCaja','GCaixa','Bizum','CaixaInc','Cash','CF','Neto','Bruto','Obs']],
      body: allRows.filter(r=>r.hasData).map(r => [
        fmtDate(r.date), r.nAlumnos, dispE(r.ePersonasN), r.nMonitores, dispE(r.eMonitoresN),
        dispE(r.camisetasN), dispE(r.alquileresN), dispE(r.gastosCajaN), dispE(r.gastosCaixaN),
        dispE(r.bizumN), dispE(r.caixaIncN), r.cash, r.cajaFuerte,
        r.neto.toFixed(2), r.bruto.toFixed(2), r.obs||'',
      ]),
      styles:     { fontSize:7, cellPadding:2 },
      headStyles: { fillColor:[26,43,60] },
    });
    doc.save('excel_skull_anual.pdf');
  }, [allRows]);

  const exportDiarioCSV = useCallback(() => {
    const csvRows = [['Fecha','Gastos','Ingresos','Saldo','Observaciones'].join(',')];
    diarioRows.filter(r=>r.hasData).forEach(r => {
      csvRows.push([
        fmtDate(r.date),
        r.gastosVal>0 ? r.gastosVal.toFixed(2) : '',
        r.ingresosVal>0 ? r.ingresosVal.toFixed(2) : '',
        r.saldoVal.toFixed(2),
        `"${String(r.obsVal||'').replace(/"/g,'""')}"`,
      ].join(','));
    });
    const blob = new Blob([csvRows.join('\n')], { type:'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href=url; a.download=`caixa_${CURRENT_YEAR}.csv`; a.click();
    URL.revokeObjectURL(url);
  }, [diarioRows]);

  const exportDiarioPDF = useCallback(() => {
    const doc = new jsPDF({ orientation:'landscape', unit:'pt', format:'a4' });
    doc.setFontSize(14);
    doc.text(`Caixa — ${CURRENT_YEAR}`, 40, 40);
    autoTable(doc, {
      startY: 60,
      head: [['Fecha','Gastos','Ingresos','Saldo Actual','Observaciones']],
      body: diarioRows.filter(r=>r.hasData).map(r => [
        fmtDate(r.date),
        r.gastosVal>0 ? r.gastosVal.toFixed(2) : '',
        r.ingresosVal>0 ? r.ingresosVal.toFixed(2) : '',
        r.saldoVal.toFixed(2),
        r.obsVal||'',
      ]),
      styles:       { fontSize:8, cellPadding:3 },
      headStyles:   { fillColor:[26,43,60] },
      columnStyles: { 1:{textColor:[224,122,95]}, 2:{textColor:[129,178,154]}, 4:{cellWidth:300} },
    });
    doc.save(`caixa_${CURRENT_YEAR}.pdf`);
  }, [diarioRows]);

  // ─────────────────────────────────────────────────────────────────────────
  // RENDER
  // ─────────────────────────────────────────────────────────────────────────
  const COL = { navy:'#1A2B3C', red:'#E07A5F', green:'#81B29A', text:'#4A6D7C', light:'#CBD5E1' };
  const thStyle = (extra={}) => ({
    padding:'6px 6px', fontSize:10, fontWeight:700, color:COL.light,
    letterSpacing:'0.04em', background:COL.navy, borderBottom:`2px solid ${COL.text}`,
    whiteSpace:'nowrap', textAlign:'center', ...extra,
  });

  const tabBtn = (id, label) => (
    <button key={id} onClick={()=>setTab(id)} style={{
      padding:'4px 14px', borderRadius:20,
      border: tab===id ? 'none' : `1.5px solid ${COL.text}`,
      background: tab===id ? COL.text : 'transparent',
      color: tab===id ? '#fff' : COL.text,
      fontWeight:600, fontSize:13, cursor:'pointer',
    }}>{label}</button>
  );

  const btnStyle = { fontSize:12, height:30, padding:'0 12px', borderRadius:8, cursor:'pointer', border:'1px solid #D1D9E0', background:'#fff', color:COL.navy, fontWeight:600 };
  const btnPrimary = { ...btnStyle, background:COL.text, color:'#fff', border:'none' };

  return (
    <div style={{ padding:'32px 20px 20px', fontFamily:'Inter, sans-serif', background:'#F8FAFC', minHeight:'100vh' }}>

      {/* ── Single header row ────────────────────────────────────────────── */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:12, gap:8, flexWrap:'wrap' }}>
        <div style={{ display:'flex', alignItems:'center', gap:6, flexWrap:'wrap' }}>
          <h1 style={{ fontSize:24, fontWeight:800, color:COL.navy, margin:0, marginRight:4 }}>Excel Skull</h1>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Buscar…"
            style={{ fontSize:12, padding:'4px 8px', borderRadius:8, border:'1px solid #D1D9E0', width:110, background:'#fff', color:COL.navy }} />
          {tabBtn('anual',  'Diario Caja')}
          {tabBtn('diario', 'Caixa')}
          {tabBtn('bizum',  'Bizum')}
          {(tab==='anual' || tab==='diario' || tab==='bizum') && (
            <>
              <div style={{ display:'flex', alignItems:'center', gap:2 }}>
                <div style={{ width:130, flexShrink:0 }}>
                  <input type="date" value={dateFrom} onChange={e=>setDateFrom(e.target.value)}
                    style={{ fontSize:12, padding:'4px 8px', borderRadius:8, border:'1px solid #D1D9E0', color:COL.navy, background:'#fff' }} />
                </div>
                {dateFrom && (
                  <button onClick={()=>setDateFrom('')} style={{ border:'none', background:'none', cursor:'pointer', color:'#8A9BA8', fontSize:14, lineHeight:1, padding:'0 2px', fontWeight:700 }}>×</button>
                )}
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:2 }}>
                <div style={{ width:130, flexShrink:0 }}>
                  <input type="date" value={dateTo} onChange={e=>setDateTo(e.target.value)}
                    style={{ fontSize:12, padding:'4px 8px', borderRadius:8, border:'1px solid #D1D9E0', color:COL.navy, background:'#fff' }} />
                </div>
                {dateTo && (
                  <button onClick={()=>setDateTo('')} style={{ border:'none', background:'none', cursor:'pointer', color:'#8A9BA8', fontSize:14, lineHeight:1, padding:'0 2px', fontWeight:700 }}>×</button>
                )}
              </div>
            </>
          )}
          {loading && <span style={{ fontSize:12, color:'#8A9BA8' }}>Cargando…</span>}
        </div>
        <div style={{ display:'flex', gap:6, alignItems:'center' }}>
          {tab==='diario' ? (
            <>
              <button style={btnStyle} onClick={exportDiarioPDF}>PDF</button>
              <button style={btnStyle} onClick={exportDiarioCSV}>Excel</button>
            </>
          ) : tab==='bizum' ? (
            <>
              <button style={btnStyle} onClick={()=>{ const recs=bizumRecipients||[]; const csvRows=[[  'Fecha',...recs.map(r=>r.name),'Observaciones'].join(',')]; bizumRows.filter(r=>r.hasData).forEach(row=>{ csvRows.push([fmtDate(row.date),...recs.map(r=>row.vals[r.id]||''),'"'+(row.obsVal||'').replace(/"/g,'""')+'"'].join(',')); }); const blob=new Blob([csvRows.join('\n')],{type:'text/csv;charset=utf-8;'}); const url=URL.createObjectURL(blob); const a=document.createElement('a'); a.href=url; a.download=`bizum_${CURRENT_YEAR}.csv`; a.click(); URL.revokeObjectURL(url); }}>Excel</button>
            </>
          ) : (
            <>
              <button style={btnStyle} onClick={exportAnualPDF}>PDF</button>
              <button style={btnStyle} onClick={exportAnualCSV}>Excel</button>
            </>
          )}
          <button style={btnPrimary} onClick={saveAll} disabled={saving}>
            {saving ? 'Guardando…' : 'Guardar todo'}
          </button>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════════════════════ */}
      {/* TAB: CAIXA (diario)                                                   */}
      {/* ══════════════════════════════════════════════════════════════════════ */}
      {tab==='diario' && (
        <div ref={diarioRef} style={{ overflow:'auto', maxHeight:'calc(100vh - 160px)', borderRadius:10, border:'1px solid #D1D9E0', background:'#fff' }}>
          <table style={{ borderCollapse:'collapse', width:'100%', tableLayout:'fixed' }}>
            <colgroup>
              <col style={{ width:82 }} />
              <col style={{ width:90 }} />
              <col style={{ width:90 }} />
              <col style={{ width:110 }} />
              <col style={{ width:500 }} />
            </colgroup>
            <thead style={{ position:'sticky', top:0, zIndex:10 }}>
              <tr style={{ background:COL.navy }}>
                {[
                  { label:'FECHA',        color:COL.light, sticky:true  },
                  { label:'GASTOS',       color:COL.red,   sticky:false },
                  { label:'INGRESOS',     color:COL.green, sticky:false },
                  { label:'SALDO ACTUAL', color:COL.light, sticky:false },
                  { label:'OBSERVACIONES',color:COL.light, sticky:false },
                ].map(({ label, color, sticky }) => (
                  <th key={label} style={{
                    ...thStyle({ textAlign: sticky ? 'left' : 'center', color }),
                    position: sticky ? 'sticky' : 'static',
                    left: sticky ? 0 : undefined,
                  }}>{label}</th>
                ))}
              </tr>
              <tr style={{ background:COL.red }}>
                <td style={{ padding:'5px 8px', fontSize:11, fontWeight:700, color:'#fff', position:'sticky', left:0, background:COL.red }}>TOTALES</td>
                <td style={{ padding:'5px 8px', fontSize:11, fontWeight:700, color:'#fff', textAlign:'center' }}>{diarioTotals.gastos>0 ? '-'+diarioTotals.gastos.toFixed(2) : ''}</td>
                <td style={{ padding:'5px 8px', fontSize:11, fontWeight:700, color:'#fff', textAlign:'center' }}>{diarioTotals.ingresos.toFixed(2)}</td>
                <td style={{ padding:'5px 8px', fontSize:11, fontWeight:700, color:'#fff', textAlign:'center' }}>{diarioTotals.saldo.toFixed(2)}</td>
                <td />
              </tr>
            </thead>
            <tbody>
              {filteredDiarioRows.map((row, idx) => {
                const newMonth = idx>0 && row.date.slice(5,7)!==filteredDiarioRows[idx-1].date.slice(5,7);
                const isToday = row.date === TODAY;
                const bg = isToday ? '#D6E8F5' : row.hasData ? '#ffffff' : '#FAFAFA';
                const bdr = isToday ? '1px solid #A8C4D8' : '1px solid #EEF1F4';
                const saldoColor = row.saldoVal>=0 ? COL.navy : COL.red;
                return (
                  <tr key={row.date} data-date={row.date} style={{ background:bg, borderTop: newMonth ? `2px solid ${COL.text}` : undefined }}>
                    <td style={{ padding:'4px 8px', position:'sticky', left:0, zIndex:1, background:bg, fontSize:11, color:COL.navy, fontWeight:row.hasData?700:400, borderBottom:bdr, whiteSpace:'nowrap' }}>
                      {fmtDate(row.date)}
                    </td>
                    <td style={{ padding:'3px 6px', borderBottom:bdr, textAlign:'center' }}>
                      <EC val={row.gastosVal>0 ? '-'+row.gastosVal.toFixed(2) : ''} onChange={v=>setV(row.date,'dc_gastos',v)} color={COL.red} edited={rows[row.date]?.['dc_gastos']!==undefined} />
                    </td>
                    <td style={{ padding:'3px 6px', borderBottom:bdr, textAlign:'center' }}>
                      <EC val={row.ingresosVal>0?row.ingresosVal.toFixed(2):''} onChange={v=>setV(row.date,'dc_ingresos',v)} color={COL.green} edited={rows[row.date]?.['dc_ingresos']!==undefined} />
                    </td>
                    <td style={{ padding:'3px 6px', borderBottom:bdr, textAlign:'center' }}>
                      <EC val={row.saldoVal.toFixed(2)} onChange={v=>setV(row.date,'dc_saldo',v)} color={saldoColor} edited={rows[row.date]?.['dc_saldo']!==undefined} style={{ fontWeight:row.saldoVal>=0?700:600 }} />
                    </td>
                    <td style={{ padding:'3px 8px', borderBottom:bdr, width:500 }}>
                      <EC val={row.obsVal} onChange={v=>setV(row.date,'dc_obs',v)} color="#8A9BA8" edited={rows[row.date]?.['dc_obs']!==undefined} align="left" />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════════════════ */}
      {/* TAB: BIZUM                                                             */}
      {/* ══════════════════════════════════════════════════════════════════════ */}
      {tab==='bizum' && (
        <div ref={bizumRef} style={{ overflow:'auto', maxHeight:'calc(100vh - 160px)', borderRadius:10, border:'1px solid #D1D9E0', background:'#fff' }}>
          <table style={{ borderCollapse:'collapse', width:'100%', tableLayout:'fixed' }}>
            <colgroup>
              <col style={{ width:90 }} />
              {(bizumRecipients||[]).map(r => <col key={r.id} style={{ width:110 }} />)}
              <col style={{ width:500 }} />
            </colgroup>
            <thead style={{ position:'sticky', top:0, zIndex:10 }}>
              <tr style={{ background:COL.navy }}>
                <th style={{ ...thStyle({ textAlign:'left', color:COL.light }), position:'sticky', left:0 }}>FECHA</th>
                {(bizumRecipients||[]).map(r => <th key={r.id} style={thStyle({ color: r.color || COL.green })}>{r.name.toUpperCase()}</th>)}
                <th style={{ ...thStyle({ textAlign:'left', color:COL.light }) }}>OBSERVACIONES</th>
              </tr>
              <tr style={{ background:COL.red }}>
                <td style={{ padding:'5px 8px', fontSize:11, fontWeight:700, color:'#fff', position:'sticky', left:0, background:COL.red }}>TOTALES</td>
                {(bizumRecipients||[]).map(r => <td key={r.id} style={{ padding:'5px 8px', fontSize:11, fontWeight:700, color:'#fff', textAlign:'center' }}>{(bizumTotals[r.id]||0)>0 ? (bizumTotals[r.id]||0).toFixed(2) : ''}</td>)}
                <td />
              </tr>
            </thead>
            <tbody>
              {filteredBizumRows.map((row, idx) => {
                const newMonth = idx>0 && row.date.slice(5,7)!==filteredBizumRows[idx-1].date.slice(5,7);
                const isToday = row.date === TODAY;
                const bg = isToday ? '#D6E8F5' : row.hasData ? '#ffffff' : '#FAFAFA';
                const bdr = isToday ? '1px solid #A8C4D8' : '1px solid #EEF1F4';
                return (
                  <tr key={row.date} data-date={row.date} style={{ background:bg, borderTop: newMonth ? `2px solid ${COL.text}` : undefined }}>
                    <td style={{ padding:'4px 8px', position:'sticky', left:0, zIndex:1, background:bg, fontSize:11, color:COL.navy, fontWeight:row.hasData?700:400, borderBottom:bdr, whiteSpace:'nowrap' }}>
                      {fmtDate(row.date)}
                    </td>
                    {(bizumRecipients||[]).map(rec => (
                      <td key={rec.id} style={{ padding:'3px 6px', borderBottom:bdr, textAlign:'right' }}>
                        <EC val={row.vals[rec.id]} onChange={v=>setV(row.date,`bz_${rec.id}`,v)} color={rec.color||COL.green} edited={rows[row.date]?.[`bz_${rec.id}`]!==undefined} forceColor={rec.color||COL.green} />
                      </td>
                    ))}
                    <td style={{ padding:'3px 8px', borderBottom:bdr, width:500 }}>
                      <EC val={row.obsVal} onChange={v=>setV(row.date,'bz_obs',v)} color="#8A9BA8" edited={rows[row.date]?.['bz_obs']!==undefined} align="left" />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* ══════════════════════════════════════════════════════════════════════ */}
      {/* TAB: DIARIO CAJA (anual excel)                                        */}
      {/* ══════════════════════════════════════════════════════════════════════ */}
      {tab==='anual' && (
        <div ref={anualRef} style={{ overflow:'auto', maxHeight:'calc(100vh - 150px)', borderRadius:10, border:'1px solid #D1D9E0', background:'#fff' }}>
          <table style={{ borderCollapse:'collapse', width:'100%' }}>
            <thead style={{ position:'sticky', top:0, zIndex:10 }}>
              {/* Row 1: group labels */}
              <tr style={{ background:COL.navy }}>
                <th rowSpan={2} style={{ ...thStyle({ textAlign:'left', minWidth:84, position:'sticky', left:0, color:'#fff', borderRight:'2px solid #4A6D7C' }) }}>FECHA</th>
                <th colSpan={2} style={{ ...thStyle({ color:'#fff', borderRight:'2px solid #4A6D7C' }) }}>Personas/clase</th>
                <th colSpan={2} style={{ ...thStyle({ color:'#fff', borderRight:'2px solid #4A6D7C' }) }}>MONITORES</th>
                <th rowSpan={2} style={{ ...thStyle({ minWidth:68, color:'#fff', borderRight:'1px solid #4A6D7C' }) }}>CAMISETAS</th>
                <th rowSpan={2} style={{ ...thStyle({ minWidth:74, color:'#fff', borderRight:'2px solid #4A6D7C' }) }}>ALQUILERES</th>
                <th rowSpan={2} style={{ ...thStyle({ minWidth:74, color:'#fff', borderRight:'1px solid #4A6D7C' }) }}>GASTOS CAJA</th>
                <th rowSpan={2} style={{ ...thStyle({ minWidth:80, color:'#fff', borderRight:'2px solid #4A6D7C' }) }}>GASTOS CAIXA</th>
                <th colSpan={3} style={{ ...thStyle({ color:'#fff', borderRight:'2px solid #4A6D7C' }) }}>Entradas de Facturación</th>
                <th rowSpan={2} style={{ ...thStyle({ minWidth:70, color:'#fff', borderRight:'2px solid #4A6D7C' }) }}>CAJA FUERTE</th>
                <th rowSpan={2} style={{ ...thStyle({ minWidth:68, color:'#fff', borderRight:'1px solid #4A6D7C' }) }}>NETO</th>
                <th rowSpan={2} style={{ ...thStyle({ minWidth:68, color:'#fff', borderRight:'2px solid #4A6D7C' }) }}>BRUTO</th>
                <th rowSpan={2} style={{ ...thStyle({ width:500, minWidth:500, textAlign:'left', color:'#fff' }) }}>Observaciones</th>
              </tr>
              {/* Row 2: sub-headers */}
              <tr style={{ background:COL.navy }}>
                <th style={{ ...thStyle({ minWidth:52, fontSize:9, color:'#fff', borderTop:'1px solid #2C4A5C', borderRight:'1px solid #4A6D7C' }) }}>Nº Alumnos</th>
                <th style={{ ...thStyle({ minWidth:62, fontSize:9, color:'#fff', borderTop:'1px solid #2C4A5C', borderRight:'2px solid #4A6D7C' }) }}>€</th>
                <th style={{ ...thStyle({ minWidth:52, fontSize:9, color:'#fff', borderTop:'1px solid #2C4A5C', borderRight:'1px solid #4A6D7C' }) }}>Nº Monitores</th>
                <th style={{ ...thStyle({ minWidth:68, fontSize:9, color:'#fff', borderTop:'1px solid #2C4A5C', borderRight:'2px solid #4A6D7C' }) }}>€</th>
                <th style={{ ...thStyle({ minWidth:58, fontSize:9, color:'#fff', borderTop:'1px solid #2C4A5C', borderRight:'1px solid #4A6D7C' }) }}>Bizum</th>
                <th style={{ ...thStyle({ minWidth:58, fontSize:9, color:'#fff', borderTop:'1px solid #2C4A5C', borderRight:'1px solid #4A6D7C' }) }}>Caixa</th>
                <th style={{ ...thStyle({ minWidth:58, fontSize:9, color:'#fff', borderTop:'1px solid #2C4A5C', borderRight:'2px solid #4A6D7C' }) }}>Cash</th>
              </tr>
              {/* Row 3: TOTAL */}
              <tr style={{ background:COL.red }}>
                {[
                  { v:'TOTAL',                    sticky:true,  bdr:'2px solid rgba(255,255,255,0.4)' },
                  { v:totals.nAlumnos||'',         sticky:false, bdr:'1px solid rgba(255,255,255,0.3)' },
                  { v:dispEuro(totals.ePersonas),     sticky:false, bdr:'2px solid rgba(255,255,255,0.4)' },
                  { v:totals.nMonitores||'',        sticky:false, bdr:'1px solid rgba(255,255,255,0.3)' },
                  { v:dispEuro(totals.eMonitores),    sticky:false, bdr:'2px solid rgba(255,255,255,0.4)' },
                  { v:dispEuro(totals.camisetas),     sticky:false, bdr:'1px solid rgba(255,255,255,0.3)' },
                  { v:dispEuro(totals.alquileres),    sticky:false, bdr:'2px solid rgba(255,255,255,0.4)' },
                  { v:dispEuro(totals.gastosCaja),    sticky:false, bdr:'1px solid rgba(255,255,255,0.3)' },
                  { v:dispEuro(totals.gastosCaixa),   sticky:false, bdr:'2px solid rgba(255,255,255,0.4)' },
                  { v:dispEuro(totals.bizum),         sticky:false, bdr:'1px solid rgba(255,255,255,0.3)' },
                  { v:dispEuro(totals.caixaInc),      sticky:false, bdr:'1px solid rgba(255,255,255,0.3)' },
                  { v:dispEuro(totals.cash),          sticky:false, bdr:'2px solid rgba(255,255,255,0.4)' },
                  { v:'',                                                          sticky:false, bdr:'2px solid rgba(255,255,255,0.4)' },
                  { v:totals.neto!==0 ? totals.neto.toFixed(2)+' €' : '',         sticky:false, bdr:'1px solid rgba(255,255,255,0.3)' },
                  { v:dispEuro(totals.bruto),                                      sticky:false, bdr:'2px solid rgba(255,255,255,0.4)' },
                  { v:'',                          sticky:false, bdr:'none' },
                ].map(({ v, sticky, bdr }, i) => (
                  <td key={i} style={{
                    padding: sticky ? '5px 8px' : '5px 4px',
                    fontSize:11, fontWeight:700, color:'#fff',
                    textAlign: sticky ? 'left' : 'center',
                    position: sticky ? 'sticky' : 'static',
                    left: sticky ? 0 : undefined,
                    background:COL.red, whiteSpace:'nowrap',
                    borderRight: bdr,
                  }}>{v}</td>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredRows.map((row, idx) => {
                const newMonth = idx>0 && row.date.slice(5,7)!==filteredRows[idx-1].date.slice(5,7);
                const ed = row.editedCols || {};
                const isToday = row.date === TODAY;
                const bH = isToday ? '1px solid #A8C4D8' : '1px solid #E8EDF2';
                const bV1 = isToday ? '1px solid #A8C4D8' : '1px solid #E0E7EF';
                const bV2 = isToday ? '2px solid #8AAEC4' : '2px solid #C8D4DE';
                const td = (bdr=bV1, extra={}) => ({ padding:'3px 6px 3px 4px', borderBottom: bH, borderRight: bdr, textAlign:'right', verticalAlign:'bottom', ...extra });
                return (
                  <tr key={row.date} data-date={row.date} style={{ background: isToday ? '#D6E8F5' : '#fff', borderTop: newMonth ? `2px solid ${COL.text}` : undefined }}>
                    <td style={{ padding:'4px 8px', position:'sticky', left:0, zIndex:1, background: isToday ? '#D6E8F5' : '#fff', fontSize:11, color:COL.navy, fontWeight:row.hasData?700:400, borderBottom: bH, borderRight: bV2, whiteSpace:'nowrap' }}>
                      {fmtDate(row.date)}
                    </td>
                    <td style={td(bV1)}><RC val={row.nAlumnos} breakdown={row.nAlBreakdown?.length>0?row.nAlBreakdown:null} /></td>
                    <td style={td(bV2)}><RC val={row.ePersonas} suffix="€" breakdown={row.ePersBreakdown?.length>0?row.ePersBreakdown:null} /></td>
                    <td style={td(bV1)}><RC val={row.nMonitores} breakdown={row.nMonBreakdown?.length>0?row.nMonBreakdown:null} /></td>
                    <td style={td(bV2)}><RC val={row.eMonitores} suffix="€" color="#E07070" breakdown={row.eMonBreakdown?.length>0?row.eMonBreakdown:null} /></td>
                    <td style={td(bV1)}><RC val={row.camisetas} suffix="€" /></td>
                    <td style={td(bV2)}><RC val={row.alquileres} suffix={`€${row.hasBizumRentals?" ⚡":""}${row.hasCaixaRentals?" 💳":""}`} breakdown={row.alqBreakdown?.length>0?row.alqBreakdown:null} /></td>
                    <td style={td(bV1)}><RC val={row.gastosCaja} suffix="€" color="#E07070" breakdown={row.gCajaBreakdown?.length>0?row.gCajaBreakdown:null} /></td>
                    <td style={td(bV2)}><RC val={row.gastosCaixa} suffix="€" color="#E07070" breakdown={row.gCaixaBreakdown?.length>0?row.gCaixaBreakdown:null} /></td>
                    <td style={td(bV1)}><RC val={row.bizum} suffix="€" breakdown={row.bizumBreakdown?.length>0?row.bizumBreakdown:null} /></td>
                    <td style={td(bV1)}><RC val={row.caixaInc} suffix="€" breakdown={row.caixaIncBreakdown?.length>0?row.caixaIncBreakdown:null} /></td>
                    <td style={td(bV2)}><RC val={row.cash} suffix="€" breakdown={row.cashBreakdown?.length>0?row.cashBreakdown:null} /></td>
                    <td style={td(bV2)}><EC val={row.cajaFuerte} onChange={v=>setV(row.date,'cajaFuerte',v)} color='#1A2B3C' edited={!!ed.cajaFuerte} suffix="€" /></td>
                    <td style={td(bV1, { textAlign:'right' })}>
                      <span style={{ fontSize:11, fontWeight:700, color: row.neto>=0 ? '#1A2B3C' : COL.red }}>
                        {row.neto!==0 ? row.neto.toFixed(2)+' €' : ''}
                      </span>
                    </td>
                    <td style={td(bV2, { textAlign:'right' })}>
                      <span style={{ fontSize:11, fontWeight:600, color:'#1A2B3C' }}>
                        {row.bruto!==0 ? row.bruto.toFixed(2)+' €' : ''}
                      </span>
                    </td>
                    <td style={{ padding:'3px 8px', borderBottom: bH, width:500, minWidth:500 }}>
                      <EC val={row.obs} onChange={v=>setV(row.date,'obs',v)} color="#8A9BA8" edited={!!ed.obs} align="left" style={{ whiteSpace:'normal', wordBreak:'break-word', lineHeight:'1.4' }} />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
